import { useEffect, useMemo, useState } from "react"
import { useParams } from "react-router-dom";
import { einwohnerHeader } from "../Tabellen/ConstTabKopf/EinwohnerKopf";
import EinwohnerUpdate from "./EinwohnerUpdate";
import { InputTabelle } from "./InputTabelle";
import TableWithoutSpecials from "../Tabellen/TableWithoutSpecials";

export default function  EinwohnerTabelle ({einwohnerInstance, zweckverbandInstance}) {
    const { uniqueYear } = useParams();
    const [currentData, setCurrentData] = useState();
    const [chosenZvs, setChosenZvs] = useState();

    
    useEffect(() => {
        einwohnerInstance.getAllEinwohnerPerYear(uniqueYear, (error, data) => {
            if (error) {
                console.log(error);
            } else {
                // console.log('load einw', data)
                if (data.length === 0) {
                    // console.log('keine Daten...')
                    zweckverbandInstance.getZweckverbandSachsenZweckverbandSachsenGet((error, data) => {
                    if (error) {
                        console.log(error);
                    } else {
                        setCurrentData();
                        setChosenZvs(data);
                    }
                    })
                } else {
                    setChosenZvs();
                    setCurrentData(data);
                }
            }
        });
    }, [einwohnerInstance, uniqueYear, zweckverbandInstance])
    
    const reloadData = (jahr) => {
        setCurrentData();
        setChosenZvs();
        einwohnerInstance.getAllEinwohnerPerYear(jahr, (error, data) => {
            if (error) {
                console.log(error);
            } else {
                setCurrentData(data);
            }
        });
    }
    const prepData = useMemo(() => currentData, [currentData]);
    const additionalColumns = {
        id: "update",
        Header: "",
        Cell: ({ row }) => (
            <div>
                <EinwohnerUpdate rowEntry={row.original} instance={einwohnerInstance} reloadData={reloadData}/>
            </div>
        )
    }
    return (
        <div style={{marginBottom: '7em'}}>
            {currentData &&
            <TableWithoutSpecials data={prepData} columns={einwohnerHeader} hiddenColumns={['id_zv', 'korr_jahr', 'id']} additionalColumns={additionalColumns} reloadData={reloadData}/>}
            {chosenZvs &&
            <InputTabelle zvs={chosenZvs} instance={einwohnerInstance} reloadData={reloadData}/>}
        </div >
    )
}

